import React, { FC } from 'react';
import { Collapse } from 'antd';
import cn from 'classnames';
import { Header } from 'components/header';
import { AngleIcon } from 'components/icons';
import styles from './styles.less';

const { Panel } = Collapse;

type LevelsCollapseProps = {
  openByDefault?: boolean;
};

export const LevelsCollapse: FC<LevelsCollapseProps> = ({ openByDefault }) => {
  const collapseClass = styles['collapse'];
  const titleClass = styles['levels-header'];
  const headerClass = styles['level-info-header'];
  const descriptionClass = styles['level-info-text'];
  const expandIconClass = styles['expand-icon'];
  const expandIconActiveClass = styles['active'];

  return (
    <Collapse
      className={collapseClass}
      ghost
      expandIcon={({ isActive }) => (
        <AngleIcon
          className={cn(expandIconClass, isActive && expandIconActiveClass)}
        />
      )}
      defaultActiveKey={openByDefault ? [1] : undefined}
    >
      <Panel
        key={1}
        header={
          <Header level={5} className={titleClass}>
            Levels
          </Header>
        }
      >
        <Header level={5} className={headerClass}>
          5 Expert
        </Header>
        <p className={descriptionClass}>
          Demonstrates broad, in-depth proficiency to be recognized as an
          authority in the applications of this skill.
        </p>
        <Header level={5} className={headerClass}>
          4 Advanced
        </Header>
        <p className={descriptionClass}>
          Demonstrates in-depth proficiency level sufficient to consult with, or
          lead others in the application of this skill.
        </p>
        <Header level={5} className={headerClass}>
          3 Intermediate
        </Header>
        <p className={descriptionClass}>
          Demonstrates a working or functional proficiency level sufficient to
          apply the skill effectively without assistance and with minimal
          supervision.
        </p>
        <Header level={5} className={headerClass}>
          2 Basic
        </Header>
        <p className={descriptionClass}>
          Demonstrates limited use of this skill. Has basic familiarity with
          subject matter area, and needs additional training to apply with
          assistance or without frequent supervision.
        </p>
        <Header level={5} className={headerClass}>
          1 Entry
        </Header>
        <p className={descriptionClass}>
          Demonstrates minimal use of this skill. Has limited knowledge of this
          subject matter area and needs frequent assistance and close
          supervision for direction. Currently developing the skill.
        </p>
      </Panel>
    </Collapse>
  );
};
